import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import {
  setFormType,
  setFormStep,
  setFormUser,
  setFormDetail,
} from "../../redux/slice/form";

import { ModuleHeadLine } from "./index";
import { word_setting } from "../../service/word";

export default function ModuleSubHead(props) {
  const { isDefault = false, lineType } = props;
  const route_navigate = useNavigate();
  const dispatch = useDispatch();
  const redux_form = useSelector((state) => state.form);

  const backHome = () => {
    dispatch(setFormType(""));
    dispatch(setFormStep(""));
    dispatch(setFormUser(null));
    dispatch(setFormDetail({}));
    route_navigate("/");
  };

  return (
    <>
      <div className="-mx-3">
        <div className="px-2 mb-2">
          {redux_form.formType && !isDefault ? (
            <>
              <span
                className="hover:text-green-300 cursor-pointer transition-colors transition-duration-200 transition-ease-in-out"
                onClick={() => backHome()}
              >
                <i className="fa fa-home"></i>
                <span className="ml-1">首頁</span>
              </span>
              <span className="mx-2">/</span>
              <span>{word_setting.pda}</span>
              <span className="mx-2">/</span>
              <span className="text-green-300">
                {word_setting[redux_form.formType]}
              </span>
            </>
          ) : (
            <>
              <span>{word_setting.sdm}</span>
              <span className="mx-2">/</span>
              <span>{word_setting.pda}</span>
            </>
          )}
        </div>

        {lineType === "one" && (
          <div className="border-bottom-3 border-main-d"></div>
        )}
        {lineType === "multi" && <ModuleHeadLine />}
      </div>
    </>
  );
}
